import { styled } from "@styles";
import { Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export const Wrapper = styled.div``;

export const UserName = styled.p`
  font-size: 1rem;
`;

export const UserNameSmall = styled.p`
  font-size: 2rem;
`;

export const Subtitle = styled.h3`
  font-size: .8rem;
  color: #888;
  margin-top: 1rem;
  text-transform: uppercase;
`;

export const SummaryCard = styled(Card)`
  width: 100%;
`;

export const ColBorder = styled(Col)`
  border-right: 1px solid rgba(0, 0, 0, 0.125);
`;

export const SummaryTitleA = styled(Link)`
`;

export const SummaryTitleH4 = styled.h4`
  color: #bab7b6;
  font-size: 1rem;
  text-align: center;
  margin-bottom: 1rem;
`;

export const SummaryValue = styled.p`
  color: #f39;
  font-size: 2rem;
  text-align: center;
`;

export const SkinTitleH4 = styled.h4`
  font-size: 1rem;
  text-align: center;
  margin-bottom: 1rem;
`;
export const SkinValue = styled.p`
  color: #f39;
  font-size: 1rem;
  text-align: center;
`;